module.exports = __webpack_public_path__ + "img/3-4.9d193131.svg";